import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const SectionList = ({ items }) => (
    <ul style={{ paddingLeft: '20px', margin: 0 }}>
        {items.map((item, i) => (
            <li
                key={i}
                style={{
                    fontWeight: 400,
                    fontSize: '15px',
                    lineHeight: '26px',
                    color: '#3B3033',
                    listStyleType: 'disc',
                    marginBottom: '4px',
                }}
            >
                {item}
            </li>
        ))}
    </ul>
);

const Organizers = () => {
    const { t } = useTranslation("organizers");

    const sections = [
        {
            title: 's1.title',
            paragraphs: ['s1.p1', 's1.p2'],
        },
        {
            title: 's2.title',
            paragraphs: ['s2.p1', 's2.p2', 's2.p3', 's2.p4', 's2.p5', 's2.p6', 's2.p7', 's2.p8', 's2.p9'],
        },
        {
            title: 's3.title',
            paragraphsBefore: ['s3.p1'],
            list: ['s3.li1', 's3.li2', 's3.li3', 's3.li4'],
            paragraphsAfter: ['s3.p2'],
        },
        {
            title: 's4.title',
            paragraphsBefore: ['s4.p1'],
            list: ['s4.li1', 's4.li2', 's4.li3', 's4.li4', 's4.li5'],
            paragraphsAfter: ['s4.p2'],
        },
        {
            title: 's5.title',
            paragraphs: ['s5.p1', 's5.p2'],
        },
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'32px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Sekcje */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>
                            {sections.map((section) => (
                                <Flex key={section.title} flexDirection={'column'} gap={'12px'}>
                                    <SectionTitle>
                                        {t(section.title)}
                                    </SectionTitle>

                                    {/* Paragrafy przed listą */}
                                    {(section.paragraphsBefore || section.paragraphs || []).map((pKey) => (
                                        <SectionParagraph key={pKey}>
                                            {t(pKey)}
                                        </SectionParagraph>
                                    ))}

                                    {/* Lista punktowana */}
                                    {section.list && (
                                        <SectionList items={section.list.map((k) => t(k))} />
                                    )}

                                    {/* Paragrafy po liście */}
                                    {(section.paragraphsAfter || []).map((pKey) => (
                                        <SectionParagraph key={pKey}>
                                            {t(pKey)}
                                        </SectionParagraph>
                                    ))}
                                </Flex>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default Organizers;
